import React from "react";
import cx from "classnames";

const Divider = ({ transparent }) => (
  <div
    className={cx("border-t border-gray-light", { "opacity-50": transparent })}
  />
);

Divider.defaultProps = {
  transparent: false,
};

export default Divider;
